define('views/modules/calendar/animated-session/animation/animation-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // events
    'services/layout',
    'services/events/animated-session-events',
    // views
    'views/parts/panel/base-panel',
    'views/parts/menu/menu',
    // views tabs
    'views/modules/calendar/animated-session/animation/animation-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // events
    LayoutState,
    AnimationEvents,
    // views
    VBasePanel,
    VPartsMenu,
    // views tabs
    VExerciseAnimationContent
) {

    var VAnimationPanel = VBasePanel.extend({
        header: {
            title: "calendar:Exercises Search",
            subtitle: "calendar:Search/Add exercises",
            // close: { class: "visible-xs-block", callback: this.onClosePanel }
        },
        tabs: [
            { id: 'search', title: 'Search', icon: 'sl-icon-magnifier', active: true, callback: 'showSearch' },
            { id: 'custom', title: 'Custom', icon: 'sl-icon-settings', callback: 'showCustom' }
        ],
        content: {
            search: VExerciseAnimationContent,
            custom: VExerciseAnimationContent,
        },
        defaultView: 'search',

        initialize: function(opt) {
            this.group = (opt || {}).group;

            this.listenTo(AnimationEvents, 'refreshPanel', this.onRefreshPanel);
        },

        getContentViewOptions: function(options) {
            return _.extend({ group: this.group }, options);
        },

        showSearch: function() {
            return this.showContent('search');
        },
        showCustom: function() {
            return this.showContent('custom', { custom: true, });
        },

        onRefreshPanel: function() {
            this.showSearch();
        }

    });

    return VAnimationPanel;
});

